const REQUEST = 'FAQ_REQUEST'
const SUCCESS = 'FAQ_SUCCESS'
const SUCCESS_RELATED = 'SUCCESS_RELATED'
const FAILURE = 'FAQ_FAILURE'
const REFINED_REQUEST = 'REFINED_FAQ_REQUEST'
const REFINED_SUCCESS = 'REFINED_FAQ_SUCCESS'
const REFINED_FAILURE = 'REFINED_FAQ_FAILURE'
const SET_ACTIVE = 'FAQ_SET_ACTIVE'
const SET_FAQ_SCORE_REQUEST = 'FAQ_SET_SCORE_REQUEST'
const SET_FAQ_SCORE_FAILURE = 'FAQ_SET_SCORE_FAILURE'
const SET_FAQ_SCORE_SUCCESS = 'FAQ_SET_SCORE_SUCCESS'
const CATEGORY_REQUEST = 'FAQ_CATEGORY_REQUEST'
const CATEGORY_SUCCESS = 'FAQ_CATEGORY_SUCCESS'
const CATEGORY_FAILURE = 'FAQ_CATEGORY_FAILURE'
const TAG_CLOUD_REQUEST = 'TAG_CLOUD_REQUEST'
const TAG_CLOUD_FAILURE = 'TAG_CLOUD_FAILURE'
const TAG_CLOUD_SUCCESS = 'TAG_CLOUD_SUCCESS'
const SAVE_FAQ_USER_HISTORY_SUCCESS = 'SAVE_FAQ_USER_HISTORY_SUCCESS'
const SAVE_FAQ_USER_HISTORY_FAILURE = 'SAVE_FAQ_USER_HISTORY_FAILURE'
const SAVE_FAQ_SCORE_FEEDBACK_REQUEST = 'SAVE_FAQ_SCORE_FEEDBACK_REQUEST'
const SAVE_FAQ_SCORE_FEEDBACK_SUCCESS = 'SAVE_FAQ_SCORE_FEEDBACK_SUCCESS'
const SAVE_FAQ_SCORE_FEEDBACK_FAILURE = 'SAVE_FAQ_SCORE_FEEDBACK_FAILURE'
const SAVE_FAQ_LOG_REQUEST = 'SAVE_FAQ_LOG_REQUEST'
const SAVE_FAQ_LOG_SUCCESS = 'SAVE_FAQ_LOG_SUCCESS'
const SAVE_FAQ_LOG_FAILURE = 'SAVE_FAQ_LOG_FAILURE'

export default {
  REQUEST,
  SUCCESS,
  SUCCESS_RELATED,
  FAILURE,
  REFINED_REQUEST,
  REFINED_SUCCESS,
  REFINED_FAILURE,
  SET_ACTIVE,
  SET_FAQ_SCORE_REQUEST,
  SET_FAQ_SCORE_FAILURE,
  SET_FAQ_SCORE_SUCCESS,
  CATEGORY_REQUEST,
  CATEGORY_SUCCESS,
  CATEGORY_FAILURE,
  TAG_CLOUD_REQUEST,
  TAG_CLOUD_FAILURE,
  TAG_CLOUD_SUCCESS,
  SAVE_FAQ_USER_HISTORY_FAILURE,
  SAVE_FAQ_USER_HISTORY_SUCCESS,
  SAVE_FAQ_SCORE_FEEDBACK_REQUEST,
  SAVE_FAQ_SCORE_FEEDBACK_SUCCESS,
  SAVE_FAQ_SCORE_FEEDBACK_FAILURE,
  SAVE_FAQ_LOG_REQUEST,
  SAVE_FAQ_LOG_SUCCESS,
  SAVE_FAQ_LOG_FAILURE,
}
